
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-end overflow-hidden bg-gradient-to-b from-stone-50 to-white">
      {/* Language Switcher */}
      <div className="absolute top-6 right-6 z-50">
        <div className="flex gap-2">
          <button className="bg-white/90 backdrop-blur-sm text-stone-700 px-4 py-2 rounded-full border border-stone-200 shadow-md hover:shadow-lg hover:scale-105 transform transition-all duration-200 font-medium text-sm whitespace-nowrap">
            日本語
          </button>
          <a 
            href="/en" 
            className="bg-white/90 backdrop-blur-sm text-stone-700 px-4 py-2 rounded-full border border-stone-200 shadow-md hover:shadow-lg hover:scale-105 transform transition-all duration-200 font-medium text-sm whitespace-nowrap"
          >
            English
          </a>
        </div>
      </div>

      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/e91717bdcce42aaa6714e1300d1627b8.jpeg"
          alt="Deaiwo Sarang Spray"
          className="w-full h-full object-cover object-[center_-66mm] md:hidden"
        />
        <img
          src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/3733c2b2442ad3e95d01d06d708c5a35.jpeg"
          alt="Deaiwo Sarang Spray"
          className="w-full h-full object-cover object-[70%_calc(-66mm+80px)] hidden md:block"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/70 via-white/20 to-transparent md:from-white/70 md:via-white/20"></div>
        
        {/* Bottom Gradient Fade */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white" style={{ background: 'linear-gradient(to bottom, transparent 0%, transparent 60%, rgba(255,255,255,0.3) 75%, rgba(255,255,255,0.7) 85%, white 100%)' }}></div>

        {/* Bottom Text Overlay */}
        <div className="absolute bottom-0 left-0 right-0 pb-8 px-6">
          <div className="max-w-7xl mx-auto">
            <p className="text-4xl md:text-5xl lg:text-6xl leading-tight w-full" style={{ fontFamily: 'Cormorant, serif', fontWeight: 300, color: '#705e44', opacity: 0.7 }}>
              Skincare research, Now for your beloved Pets
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 pb-24 pt-32 md:pb-32 md:pt-40">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-xl md:max-w-2xl text-left space-y-8 md:space-y-10 md:scale-120 md:origin-left md:-translate-y-16">
            {/* Logo/Brand */}
            <div className="inline-block">
              <h1 className="w-32 md:w-40">
                <img 
                  src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/8646bf9aab5950bd375bfa6dd90695e7.png" 
                  alt="DEAIWO" 
                  className="w-full h-auto md:drop-shadow-none drop-shadow-[0_0_30px_rgba(255,255,255,1)]"
                />
              </h1>
            </div>

            {/* Main Headline */}
            <div className="space-y-6 md:space-y-8">
              <h2 className="leading-tight md:drop-shadow-none" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                <span className="md:hidden text-[2.7rem]" style={{ fontWeight: 500, color: '#705e44', textShadow: '0 0 25px rgba(255,255,255,1), 0 0 50px rgba(255,255,255,0.9), 0 0 75px rgba(255,255,255,0.7), 0 0 100px rgba(255,255,255,0.5)' }}>愛する家族に、<br />最高の<br />サラうる<br />体験を</span>
                <span className="hidden md:inline text-6xl lg:text-7xl" style={{ fontWeight: 400, color: '#705e44', textShadow: 'none' }}>愛する家族に、<br />最高のサラうる<br />体験を</span>
              </h2>
              
              <div className="pt-4 md:pt-6">
                <p className="text-3xl md:text-4xl tracking-wide md:drop-shadow-none" style={{ fontFamily: 'Playfair Display, serif' }}>
                  <span className="md:hidden" style={{ fontWeight: 500, color: '#705e44', textShadow: '0 0 25px rgba(255,255,255,1), 0 0 50px rgba(255,255,255,0.9), 0 0 75px rgba(255,255,255,0.7), 0 0 100px rgba(255,255,255,0.5)' }}>Deaiwo Sarang Spray</span>
                  <span className="hidden md:inline" style={{ fontWeight: 400, color: '#705e44', textShadow: 'none' }}>Deaiwo Sarang Spray</span>
                </p>
                <p className="text-base md:text-lg mt-4 tracking-wide md:drop-shadow-none" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                  <span className="md:hidden" style={{ fontWeight: 500, color: '#705e44', textShadow: '0 0 25px rgba(255,255,255,1), 0 0 50px rgba(255,255,255,0.9), 0 0 75px rgba(255,255,255,0.7), 0 0 100px rgba(255,255,255,0.5)' }}>ラグジュアリー  グルーミングスプレー</span>
                  <span className="hidden md:inline" style={{ fontWeight: 400, color: '#705e44', textShadow: 'none' }}>ラグジュアリー グルーミングスプレー</span>
                </p>
              </div>
            </div>
          </div>

          {/* Scroll Indicator - Centered */}
          <div className="pt-16 flex justify-center">
            <div className="inline-flex flex-col items-center gap-3 animate-bounce">
              <div className="w-px h-12 bg-gradient-to-b from-transparent via-stone-500 to-transparent"></div>
              <i className="ri-arrow-down-line text-stone-500 text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
